<script setup lang="ts">
import { computed } from "vue";
import { getLegacyApp } from "../../core/legacy-bridge";
import { materialLibrary } from "../../data";
import { t } from "../../i18n";
import { appStore } from "../../stores/app";
import { currentMaterial, getSelectionConfiguration, materialSelection, materialThumbnail, refreshMaterialSelection } from "./materialSelection";

// Everything is re-read when materialSelection.version changes (the configuration is not reactive)
const view = computed(() => {
    materialSelection.version;
    const material = currentMaterial();
    if (!material) return null;
    const group = materialSelection.group || material.group;
    return {
        material,
        groupLabel: materialSelection.group,
        items: materialLibrary.materials.filter(m => m.group === group),
    };
});

function selectMaterial(productNumber: string) {
    getSelectionConfiguration().data["material"] = productNumber;
    refreshMaterialSelection();
    getLegacyApp().onMaterialSelected();
}

function openGroupModal() {
    appStore.modal = "materialGroup";
}
</script>

<template>
    <div class="material-selector selector">
        <div class="selector__wrapper">
            <div class="selector__nav">
                <div class="selector__nav__left">
                    <div class="material-selector__header">
                        <span v-html="t('page.viewport.currentmaterial')"></span>
                        <span class="material-selector__material__name">{{ view ? `${view.material.name} (pricegroup: ${view.material.priceGroup})` : "" }}</span>
                    </div>
                </div>
                <div class="selector__nav__right">
                    <div class="material-selector__header bulma-contextual">
                        <div class="material-selector__header__section"><span v-html="t('page.viewport.selectedfabric')"></span><span class="material-selector__group__name">{{ view?.groupLabel }}</span></div>
                        <div class="material-selector__header__section"><a class="material-selector__items__group__select" href="" @click.prevent="openGroupModal" v-html="t('page.viewport.selectfabric')"></a></div>
                    </div>
                </div>
            </div>

            <div class="selector__content">
                <div class="selector__content__left">
                    <div class="material-selector__material__image" :style="view ? { backgroundImage: `url('${materialThumbnail(view.material)}')` } : {}">
                    </div>
                </div>
                <div class="material-selector__items selector__content__right">
                    <!-- Scrolls when the colours don't fit in 100px (replaces the YUI ScrollView) -->
                    <div style="height: 100px; overflow-y: auto;">
                        <ul class="selector__items">
                            <li v-for="item in view?.items" :key="item.productNumber" :data-id="item.productNumber" :class="{ 'is-active': item.productNumber === view.material.productNumber }" @click="selectMaterial(item.productNumber)">
                                <div :style="{ backgroundImage: `url('${materialThumbnail(item)}')` }"></div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
